function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".timer-outer-cls-1,.timer-outer-cls-2{fill:none;stroke:#fff;}.timer-outer-cls-1{stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.timer-outer-cls-2{stroke-miterlimit:10;stroke-width:0.5px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "Contenu"
}, React.createElement("line", {
  className: "timer-outer-cls-1",
  x1: 109.35,
  y1: 1.5,
  x2: 109.35,
  y2: 11.54
}), React.createElement("line", {
  className: "timer-outer-cls-1",
  x1: 109.35,
  y1: 11.54,
  x2: 109.35,
  y2: 1.5
}), React.createElement("line", {
  className: "timer-outer-cls-1",
  x1: 1.5,
  y1: 108.91,
  x2: 11.54,
  y2: 108.91
}), React.createElement("line", {
  className: "timer-outer-cls-1",
  x1: 206.78,
  y1: 109.09,
  x2: 216.82,
  y2: 109.12
}), React.createElement("line", {
  className: "timer-outer-cls-1",
  x1: 109.21,
  y1: 206.78,
  x2: 109.21,
  y2: 216.82
}), React.createElement("line", {
  className: "timer-outer-cls-1",
  x1: 216.82,
  y1: 109.12,
  x2: 206.78,
  y2: 109.09
}), React.createElement("line", {
  className: "timer-outer-cls-1",
  x1: 11.54,
  y1: 108.91,
  x2: 1.5,
  y2: 108.91
}), React.createElement("line", {
  className: "timer-outer-cls-1",
  x1: 109.21,
  y1: 216.82,
  x2: 109.21,
  y2: 206.78
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 134.77,
  y1: 14.93,
  x2: 137.39,
  y2: 5.25
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 55.38,
  y1: 15.87,
  x2: 60.43,
  y2: 24.55
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 84.22,
  y1: 14.75,
  x2: 81.62,
  y2: 5.06
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 81.62,
  y1: 5.06,
  x2: 84.22,
  y2: 14.75
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 14.77,
  y1: 84.17,
  x2: 5.04,
  y2: 81.67
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 15.74,
  y1: 55.61,
  x2: 24.48,
  y2: 60.55
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 40.31,
  y1: 39.95,
  x2: 33.19,
  y2: 32.88
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 33.19,
  y1: 32.88,
  x2: 40.31,
  y2: 39.95
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 60.43,
  y1: 24.55,
  x2: 55.38,
  y2: 15.87
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 5.04,
  y1: 81.67,
  x2: 14.77,
  y2: 84.17
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 24.48,
  y1: 60.55,
  x2: 15.74,
  y2: 55.61
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 213.5,
  y1: 82.55,
  x2: 203.77,
  y2: 85
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 202.92,
  y1: 56.22,
  x2: 194.16,
  y2: 61.13
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 203.77,
  y1: 85,
  x2: 213.5,
  y2: 82.55
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 185.84,
  y1: 33.6,
  x2: 178.68,
  y2: 40.63
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 194.16,
  y1: 61.13,
  x2: 202.92,
  y2: 56.22
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 163.49,
  y1: 16.2,
  x2: 158.42,
  y2: 24.86
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 178.68,
  y1: 40.63,
  x2: 185.84,
  y2: 33.6
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 137.39,
  y1: 5.25,
  x2: 134.77,
  y2: 14.93
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 158.42,
  y1: 24.86,
  x2: 163.49,
  y2: 16.2
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 163.42,
  y1: 202.16,
  x2: 158.37,
  y2: 193.48
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 134.83,
  y1: 203.37,
  x2: 137.47,
  y2: 213.05
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 202.71,
  y1: 162.47,
  x2: 194,
  y2: 157.47
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 178.34,
  y1: 178.04,
  x2: 185.43,
  y2: 185.13
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 137.47,
  y1: 213.05,
  x2: 134.83,
  y2: 203.37
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 185.43,
  y1: 185.13,
  x2: 178.34,
  y2: 178.04
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 158.37,
  y1: 193.48,
  x2: 163.42,
  y2: 202.16
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 203.46,
  y1: 134.46,
  x2: 213.15,
  y2: 137.1
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 213.15,
  y1: 137.1,
  x2: 203.46,
  y2: 134.46
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 194,
  y1: 157.47,
  x2: 202.71,
  y2: 162.47
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 33.26,
  y1: 185.51,
  x2: 40.3,
  y2: 178.36
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 24.73,
  y1: 158.2,
  x2: 16.08,
  y2: 163.29
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 5.27,
  y1: 137.47,
  x2: 14.93,
  y2: 134.77
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 84.05,
  y1: 203.52,
  x2: 81.5,
  y2: 213.23
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 16.08,
  y1: 163.29,
  x2: 24.73,
  y2: 158.2
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 14.93,
  y1: 134.77,
  x2: 5.27,
  y2: 137.47
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 81.5,
  y1: 213.23,
  x2: 84.05,
  y2: 203.52
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 60.98,
  y1: 194.08,
  x2: 56.07,
  y2: 202.83
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 56.07,
  y1: 202.83,
  x2: 60.98,
  y2: 194.08
}), React.createElement("line", {
  className: "timer-outer-cls-2",
  x1: 40.3,
  y1: 178.36,
  x2: 33.26,
  y2: 185.51
})));

var SvgTimerOuter = function SvgTimerOuter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 218.32 218.32",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimerOuter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer-outer.9112ab75.svg";
export { ForwardRef as ReactComponent };